import RoomCatalog from './RoomCatalog'

export { RoomCatalog }


// WEBPACK FOOTER //
// ./src/features/Hotel/containers/index.js